"use strict";
/** A pad's count of parked taps (ai/nba/N8-taps/PLAN.md §19.3, §19a.5); held, it copies them (handlers/parked-hold.ts). */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PARKED_HTML = void 0;
exports.showParked = showParked;
/** Its own element, so the status text is replaced around it and it never shrinks. */
exports.PARKED_HTML = '<span class="tap-parked" role="button" hidden></span>';
/** "N parked", or hidden when nothing is. */
function showParked(el, count) {
    if (!el)
        return;
    el.hidden = count === 0;
    const text = count === 0 ? "" : `${count} parked`;
    if (el.textContent !== text)
        el.textContent = text;
}
